import axios from "axios";
import { getAdminToken } from "./adminAuth";
import { getPortalToken } from "./portalAuth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Automatically attach Authorization: Bearer <token> from localStorage.
// Backend still accepts ?token= for backward compatibility with old links.
api.interceptors.request.use((cfg) => {
  const url = cfg.url || "";
  const token =
    (url.includes("/admin") && getAdminToken()) ||
    (url.includes("/portal") && getPortalToken()) ||
    "";
  if (token && !cfg.headers?.Authorization) {
    cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${token}` };
  }
  return cfg;
});

// Site Content preview mode: when the public site is opened with ?preview=1,
// merge the unsaved-draft settings stashed in sessionStorage over the real
// /settings response. Admin -> Site Content writes the draft when the user
// clicks "Preview changes".
api.interceptors.response.use((res) => {
  try {
    const url = res.config?.url || "";
    const isSettings = url === "/settings" || url.endsWith("/settings");
    if (isSettings && typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      if (params.get("preview") === "1") {
        const raw = sessionStorage.getItem("zca_site_preview");
        if (raw) {
          const draft = JSON.parse(raw);
          res.data = { ...(res.data || {}), ...draft };
        }
      }
    }
  } catch { /* ignore preview merge errors */ }
  return res;
});

